import React from 'react';
import { Button, Badge } from 'reactstrap';
import axiosInstance from '@src/axios-instance';
import ConfirmModal from '@components/ConfirmModal/ConfirmModal';

class Attachments extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      items: [],
      loaded: false,
      confirmModalActive: false,
      activeId: null
    };

    this.loadList();
  }

  openFilePicker = () => {
    this.fileUpload.click();
  };

  toggle = modalType => {
    this.setState(prevState => ({
      [modalType]: !prevState[modalType]
    }));
  };

  loadList = e => {
    axiosInstance()
      .get(`/attachments.json`, {
        params: { evidence_of_insurance_id: this.props.entityId }
      })
      .then(response => {
        this.setState({
          items: response.data.list,
          loaded: true
        });
      })
      .catch(err => {
        alert(err.response.data.message);
      });
  };

  onFileRemove = e => {
    axiosInstance()
      .delete(`/attachments/${this.state.activeId}.json`)
      .then(response => {
        this.setState({
          confirmModalActive: false,
          items: response.data.list
        });
        this.props.getEntity();
      })
      .catch(err => {
        alert('Error');
      });
  };

  onFileSelect = e => {
    if (this.fileUpload.files.length > 0) {
      const formData = new FormData();
      if (this.fileUpload.files[0].size / 1024 / 1024 > 8) {
        alert(
          "The file you're trying to upload is above the file size limit (8MB)."
        );
        this.fileUpload.value = '';
        return false;
      }
      formData.append('file_path', this.fileUpload.files[0]);
      formData.append('evidence_of_insurance_id', this.props.entityId);
      formData.append('file_name', this.fileUpload.files[0].name);
      axiosInstance()
        .post(`/attachments.json`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(response => {
          this.setState({
            confirmModalActive: false,
            items: response.data.list
          });
          this.props.getEntity();
        })
        .catch(err => {
          alert(err.response.data.message);
        });
      this.fileUpload.value = '';
    }
  };

  downloadPDF = (response, name) => {
    const byteCharacters = window.atob(response);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray]);
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', name);
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
  };

  downloadEmailAttachment = entityId => {
    axiosInstance()
      .get(`/attachments/${entityId}.json`)
      .then(response => {
        this.downloadPDF(response.data.response, response.data.name);
      })
      .catch(err => {
        console.log('Exception');
      });
  };

  render = () => {
    return (
      <div id={'sample-quote-area'} className={'pt-2'}>
        <input
          ref={ref => (this.fileUpload = ref)}
          type={'file'}
          className={'d-none'}
          onChange={this.onFileSelect}
        />
        {this.state.items.map(item => {
          return (
            <div className={'d-flex align-items-center py-1'}>
              <div
                className={'btn-link pointer'}
                onClick={() => this.downloadEmailAttachment(item.id)}
              >
                {item.file_name}
              </div>
              <Button
                color={'link'}
                className={'py-0'}
                onClick={() =>
                  this.setState({
                    activeId: item.id,
                    confirmModalActive: true
                  })
                }
              >
                Delete
              </Button>
            </div>
          );
        })}
        {this.state.loaded && (
          <React.Fragment>
            <Button
              size={'sm'}
              color={'link'}
              className={'mr-2 ml-0 pb-2 px-0'}
              onClick={this.openFilePicker}
            >
              Attach New File
            </Button>
            {this.props.isMasterCert && this.state.items.length === 0 && (
              <Badge color={'danger'}>Warning: No Attachment</Badge>
            )}
          </React.Fragment>
        )}

        <ConfirmModal
          isActive={this.state.confirmModalActive}
          title={'Confirmation'}
          toggle={() => this.toggle('confirmModalActive')}
          body={
            'Please confirm before deleting this file. This action is not reversable.'
          }
          confirmLabel={'Yes, delete this file'}
          confirmAction={this.onFileRemove}
        />
      </div>
    );
  };
}

export default Attachments;
